import { ArrowDown } from "lucide-react";
import { Chapter, MaskedLine, Reveal } from "../components/motion";
import { config } from "../config/siteConfig";

const Problem = () => (
  <section
    id="problem"
    data-testid="problem-section"
    className="bg-[#F7F8FA] text-[#08162B] py-24 lg:py-36"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter index="02" label="The Problem" />

      <h2 className="mt-10 font-display tracking-[0.02em] leading-[1.02] text-[clamp(2rem,5vw,4rem)] max-w-5xl">
        <MaskedLine delay={0.1}>ECOMMERCE ISN'T TOO COMPLICATED.</MaskedLine>
      </h2>
      <p className="mt-6 font-sans font-extrabold uppercase tracking-tighter leading-[0.95] text-[clamp(2.2rem,6.5vw,5.5rem)] max-w-6xl">
        <MaskedLine delay={0.25} className="text-[#08162B]/25">
          THE INTERNET MADE IT COMPLICATED.
        </MaskedLine>
      </p>

      <Reveal delay={0.2} className="mt-14 max-w-3xl">
        <p className="text-lg sm:text-xl leading-relaxed text-[#5A6E85]">
          Aspiring entrepreneurs are drowning in advice. Every platform, every guru, every tool
          shouting a different tactic — none of them in any order.
        </p>
      </Reveal>

      <div className="mt-10 flex flex-wrap gap-3 max-w-4xl" data-testid="noise-list">
        {config.noise.map((item, i) => (
          <Reveal key={item} delay={0.1 + i * 0.05} y={16}>
            <span className="inline-block border border-[#08162B]/15 bg-white px-4 py-2.5 font-mono text-[11px] sm:text-xs uppercase tracking-[0.15em] text-[#08162B]/70">
              {item}
            </span>
          </Reveal>
        ))}
      </div>

      <div className="mt-16 grid lg:grid-cols-2 gap-6 max-w-5xl">
        <Reveal delay={0.15}>
          <div className="border-l-2 border-[#08162B]/20 pl-6 py-2">
            <p className="font-condensed text-xl sm:text-2xl text-[#08162B]/60">
              Everyone tells you <em>what</em> to do.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="border-l-2 border-[#D4AF37] pl-6 py-2">
            <p className="font-condensed text-xl sm:text-2xl text-[#08162B]">
              Very few tell you <em>when</em> to do it.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} className="mt-20">
        <div className="flex items-center gap-5">
          <span className="flex items-center justify-center h-12 w-12 rounded-full bg-[#08162B] text-white">
            <ArrowDown size={18} />
          </span>
          <p className="font-sans font-extrabold uppercase tracking-tight text-2xl sm:text-4xl">
            THERE'S A BETTER WAY.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Problem;
